//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalWithTitleBar from '@/components/Shared/ModalWithTitleBar'
import Button from '@/components/Shared/Button'

export default {
  name: 'MagicLinkContactMethods',
  components: {
    Button,
    ModalWithTitleBar,
  },
  props: {
    title: {
      type: String,
      default: 'Inicia Sesión con enlace',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
      default: null,
    },
    email: {
      type: String,
      default: '',
    },
    phone: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      methodContactValue: null,
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
      this.resetForm()
    },
    submit() {
      this.$emit('submit', this.methodContactValue)
      this.resetForm()
    },
    resetForm() {
      this.methodContactValue = null
    },
    isChileanPhone(phone) {
      if (!phone) return false
      return phone.startsWith('+56')
    },
  },
}
